import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/apiClient";
import { ProductCard } from "../components/ProductCard";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/products?search=${encodeURIComponent(q)}`).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [q]);

  return (
    <div data-testid="search-page" className="mx-auto max-w-7xl px-6 md:px-12 py-16 min-h-[60vh]">
      <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-3">Search results</div>
      <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium mb-8">"{q}"</h1>
      {loading ? (
        <p className="text-zinc-400">Searching…</p>
      ) : products.length === 0 ? (
        <p className="text-zinc-400" data-testid="search-empty">No products matched your search.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
